import type { ExpertGuide } from '../../types';

import type { MetaDataContext } from './types';

type Props = {
  data: {
    guide: ExpertGuide;
  };
};

const expertGuide = ({ data }: Props, { t }: MetaDataContext) => {
  if (!data || !data.guide) {
    return {};
  }

  const { guide } = data;

  const title =
    guide.metaTitle?.replace('Advized.se', t('meta', 'site.name')) ||
    t('meta', 'expert.guide-title', {
      title: guide.title,
    });

  const description =
    guide.description ||
    t('meta', 'expert.guide-description', {
      category: guide.category.name.toLowerCase(),
    });

  const openGraph = [
    { key: 'url', content: guide.fullUrl },
    { key: 'title', content: title },
    { key: 'description', content: description },
    { key: 'type', content: 'article' },
    { key: 'image', content: guide.image?.src },
    { key: 'siteName', content: t('meta', 'site.name') },
  ];

  return {
    description,
    title,
    canonical: guide.fullUrl,
    openGraph,
    structuredData: undefined,
  };
};

export default expertGuide;
